import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const AgentCenter: RouteConfig = {
  path: '/agent-center',
  component: Layout,
  redirect: 'noredirect',
  name: 'agentManagement',
  meta: {
    title: 'agentcenter',
    permission: 'agentManagement',
    icon: 'peoples'
  },
  children: [{
    path: 'agent-manage/index',
    component: () => import(/* webpackChunkName: "agentUserManagement" */ '@/views/agentcenter/agentmanage/index.vue'),
    name: 'agentUserManagement',
    meta: {
      title: 'agentmanage',
      permission: 'agentUserManagement',
      noCache: true,
      icon: 'agent-manage'
    }
  },
  {
    path: 'member-manage/index',
    component: () => import(/* webpackChunkName: "customerCenter" */ '@/views/agentcenter/membercenter/index.vue'),
    name: 'customerCenter',
    meta: {
      title: 'membercenter',
      permission: 'customerCenter',
      noCache: true,
      icon: 'agent-center'
    }
  },
  {
    path: '/agent-detail/index',
    component: () => import(/* webpackChunkName: "agentdetail" */ '@/views/agentcenter/agentmanage/detail/index.vue'),
    name: 'agentdetail',
    meta: {
      title: 'agentdetail',
      activeMenu: '/agent-center/agent-manage/index',
      hidden: true,
      icon: 'guide'
    }
  },
  {
    path: '/member-detail/index',
    component: () => import(/* webpackChunkName: "memberdetail" */ '@/views/agentcenter/membercenter/detail/index.vue'),
    name: 'memberdetail',
    meta: {
      title: 'memberdetail',
      activeMenu: '/agent-center/member-manage/index',
      hidden: true,
      icon: 'guide'
    }
  },
  {
    path: '/member-update/index',
    component: () => import(/* webpackChunkName: "memberupdate" */ '@/views/agentcenter/membercenter/detail/grantuserinfo.vue'),
    name: 'memberupdate',
    meta: {
      title: 'memberupdate',
      activeMenu: '/agent-center/member-manage/index',
      hidden: true,
      icon: 'guide'
    }
  }]
}

export default AgentCenter
